import { load as actionLoad } from './actions';

export default (engine: any) => (store: any) => {
    const dispatchLoad = (state: any) => store.dispatch(actionLoad(state));
    return engine.load().then((newState: any) => {
        dispatchLoad(newState);
        return newState;
    });
};
